import React from 'react';
import { Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useMaturityMode } from '../hooks/useMaturityMode';
import type { MaturityType } from './MaturityTag';

interface MaturityAlertProps {
    type: MaturityType;
    style?: React.CSSProperties;
}

export const MaturityAlert: React.FC<MaturityAlertProps> = ({ type, style }) => {
    const { isBetaMode, isEarlyAccessMode, betaMessage, earlyAccessMessage } = useMaturityMode();

    if (type === 'beta' && !isBetaMode) return null;
    if (type === 'earlyAccess' && !isEarlyAccessMode) return null;

    const config = type === 'beta'
        ? {
            message: betaMessage,
            background: '#f9f0ff',
            border: '1px solid #d3adf7',
            iconColor: '#9254de',
        }
        : {
            message: earlyAccessMessage,
            background: '#f6ffed',
            border: '1px solid #b7eb8f',
            iconColor: '#389e0d',
        };

    return (
        <Alert
            message={config.message}
            type="info"
            showIcon
            icon={<InfoCircleOutlined style={{ color: config.iconColor }} />}
            style={{
                marginBottom: 24,
                background: config.background,
                border: config.border,
                ...style,
            }}
        />
    );
};
